import { create } from "zustand";

type TEntitiesFilterStore = {
  filters: Record<string, string[]>;
  addFilter: (filterKey: string, value: string) => void;
  removeFilter: (filterKey: string, value: string) => void;
  resetFilters: (filterKey: string) => void;
  resetAllFilters: () => void;
  getValues: (filterKey: string) => string[];
};

export const useEntitiesFilterBaseStore = create<TEntitiesFilterStore>((set, get) => ({
  filters: {},
  addFilter: (filterKey, value) =>
    set((state) => {
      const existingFilters = state.filters[filterKey] || [];
      if (existingFilters.includes(value)) return state;

      return {
        filters: {
          ...state.filters,
          [filterKey]: [...existingFilters, value],
        },
      };
    }),
  removeFilter: (filterKey, value) =>
    set((state) => ({
      filters: {
        ...state.filters,
        [filterKey]: (state.filters[filterKey] || []).filter((item) => item !== value),
      },
    })),
  resetFilters: (filterKey) =>
    set((state) => ({
      filters: {
        ...state.filters,
        [filterKey]: [],
      },
    })),
  resetAllFilters: () => set({ filters: {} }),
  getValues: (filterKey) => get().filters[filterKey] || [],
}));

export const useEntitiesFilterStore = (filterKey: string) => {
  const addFilter = useEntitiesFilterBaseStore((state) => state.addFilter);
  const removeFilter = useEntitiesFilterBaseStore((state) => state.removeFilter);
  const resetFilters = useEntitiesFilterBaseStore((state) => state.resetFilters);
  const filters = useEntitiesFilterBaseStore((state) => state.filters);

  const values = filterKey === "all" ? Object.values(filters).flat() : filters[filterKey] || [];

  return {
    values,
    filters,
    addFilter: (value: string) => addFilter(filterKey, value),
    removeFilter: (value: string) => removeFilter(filterKey, value),
    resetFilters: () => resetFilters(filterKey),
  };
};
